/**
 * Build a `url(...)` reference to an in-document SVG fragment (marker,
 * filter, gradient, clipPath).
 *
 * Safari/WebKit resolves a fragment-only reference like `url(#arrow)`
 * against the *document* URL, and silently fails to find the in-document
 * element once that URL carries a query string — which the site stamps
 * (`?ex=` / `?src=`) via history.replaceState. Anchoring the reference to
 * the current document URL (sans hash) keeps the lookup same-document in
 * every browser.
 *
 * Use this for every `url(#...)` SVG reference rendered into the live DOM.
 * Standalone SVG output (file export) should keep plain `url(#id)` — there
 * the document IS the SVG.
 */
export function svgFragmentUrl(id: string): string {
  if (typeof window === "undefined") return `url(#${id})`;
  return `url(${window.location.href.split("#")[0]}#${id})`;
}
